// Дерево бокового меню из раскладки админки (владелец 15.10: пункты можно перетаскивать и вкладывать в разделы в
// «Меню сайта»). Раскладка — [{id, parent}] в порядке следования; парент — id раздела-группы, глубина одна.
// В коде остаются только адреса, иконки и подписи пунктов; порядок и вложенность — из карты сервера, пока карты нет —
// из fallback (то же, что в коде). Чистая функция — тесты без DOM; та же проверка, что normalize_layout на сервере.
import type { NavLayout } from '../api/nav'

export interface NavTreeNode<T> {
	item: T
	children: T[]
}

export function buildNavTree<T extends { id: string }>(defs: T[], layout: NavLayout | null, fallback: NavLayout): NavTreeNode<T>[] {
	const byId = new Map(defs.map((d) => [d.id, d]))
	const rows = layout && layout.length ? layout : fallback
	const order: string[] = []
	const parents = new Map<string, string | null>()
	for (const row of rows) {
		if (!byId.has(row.id) || parents.has(row.id)) continue
		order.push(row.id)
		parents.set(row.id, row.parent && byId.has(row.parent) && row.parent !== row.id ? row.parent : null)
	}
	// Пункт, которого нет в раскладке (новый раздел в коде), — в конец, с родителем из fallback.
	for (const row of fallback) {
		if (!byId.has(row.id) || parents.has(row.id)) continue
		order.push(row.id)
		parents.set(row.id, row.parent && byId.has(row.parent) ? row.parent : null)
	}
	// Глубина одна: у кого родитель сам вложен — наверх (нижнее звено цепочки), как на сервере.
	let changed = true
	while (changed) {
		changed = false
		for (const id of order) {
			const p = parents.get(id)
			if (p && parents.get(p)) {
				parents.set(id, null)
				changed = true
			}
		}
	}
	return order
		.filter((id) => !parents.get(id))
		.map((id) => ({
			item: byId.get(id) as T,
			children: order.filter((cid) => parents.get(cid) === id).map((cid) => byId.get(cid) as T),
		}))
}
